import trace from '~/lib/trace';
import React, {useState, useEffect} from 'react';
import {View} from 'react-native';
import PropTypes from 'prop-types';

import sy from '~/styles';
import {user as userApi} from '~/api/private';

import {Text} from '~/components/controls';

const UserLabel = ({style, user_id}) => {
  const [label, setLabel] = useState(null);

  useEffect(() => {
    const fetch = async () => {
      const {first_name, short_form} = (await userApi.find(user_id)) ?? {};

      setLabel(short_form?.partner ?? first_name);
    };

    if (user_id) {
      fetch().catch(trace);
    }
  }, [user_id]);

  if (!label) {
    return null;
  }

  return (
    <View
      style={[
        sy['py-1'],
        sy['px-2'],
        {
          backgroundColor: '#B29A74',
          position: 'absolute',
          right: 0,
          bottom: 0,
          borderTopLeftRadius: 8,
        },
        style,
      ]}>
      <Text style={[sy.smallRegular, sy['text-white']]}>{label}</Text>
    </View>
  );
};

UserLabel.propTypes = {
  style: PropTypes.any,
  user_id: PropTypes.any,
};

export default UserLabel;
